import { z } from 'zod'

export const ADMINDESKTOPAGENTSPATCH_CONTRACT_VERSION = '1.0.0' as const
export const adminDesktopAgentsPatchResponseSchema = z.unknown()
export type AdminDesktopAgentsPatchResponse = z.infer<typeof adminDesktopAgentsPatchResponseSchema>
